import React from 'react';

function EmptyState() {
  return (
    <div className="empty-state">
      <div className="empty-icon">📋</div>
      <h2 className="heading heading--h2">No Pending Quotes</h2>
      <p>You don't have any quotes at this time.</p>
    </div>
  );
}

export default EmptyState;
